import { ThemeOptions } from '@mui/material';

const fontFamily = [
  'Montserrat',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(', ');

const typography: NonNullable<ThemeOptions['typography']> = (_palette) => ({
  fontFamily,
  h2: {
    fontFamily,
    fontWeight: 500,
    fontSize: `${24 / 16}rem`,
    lineHeight: (29 / 24).toPrecision(3),
  },
  h3: {
    fontFamily,
    fontWeight: 500,
    fontSize: `${20 / 16}rem`,
    lineHeight: (24 / 20).toPrecision(3),
    letterSpacing: '0.0015em',
  },
  body1: {
    fontFamily,
    fontSize: `${16 / 16}rem`,
    lineHeight: (26 / 16).toPrecision(3),
    letterSpacing: '0.005em',
  },
  body2: {
    fontFamily,
    fontSize: `${14 / 16}rem`,
    lineHeight: (20 / 14).toPrecision(3),
    letterSpacing: '0.0025em',
  },
  button: {
    fontFamily,
    fontSize: `${14 / 16}rem`,
    lineHeight: (17 / 14).toPrecision(3),
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
});

export default typography;
